// extracted by mini-css-extract-plugin
export default {"container":"ErrorModal-module_container__nsDRA","title":"ErrorModal-module_title__K0BGJ","descriptionCont":"ErrorModal-module_descriptionCont__meBZm"};